<template>
  <div>
    <div
      class="d-flex justify-content-center align-items-center products-container"
    >
      <div class="row justify-content-center">
        <product
          v-for="product in products"
          :product="product"
          @click="itemClick(product)"
          @decrease="decrease(product)"
          @increase="increase(product)"
          :key="product.id"
          :selected="isSelected(product)"
          :colorSchema="colorSchema != '' ? colorSchema : '#8B8B8B'"
          :cssString="cssString"
          style
        />
      </div>
    </div>
  </div>
</template>

<script>
import product from "./product";

export default {
  name: "product-selection",
  components: { product },
  props: {
    products: Array,
    endpoint: String,
    successAction: Object,
    colorSchema: {
      required: false,
      type: String,
      default: "#8B8B8B"
    },
    maxSelectable: {
      required: false,
      type: [String, Number],
      default: -1
    },
    minSelectable: {
      required: false,
      type: [String, Number],
      default: -1
    },
    texts: {
      required: false,
      type: Object,
      default: () => {}
    },
    styles: {
      type: Object
    },
    selected:{
      type:[Array,Object],
      default:()=>[]
    },
    fieldId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cssString: "",
      selectedItems: this.selected
    };
  },
  watch: {
    styles: {
      immediate: true,
      handler() {
        const keys = Object.keys(this.styles);
        const vals = Object.values(this.styles);
        keys.forEach((key, idx) => (this.cssString += key + ":" + vals[idx]));
      }
    }
  },
  computed: {
    numberOfSelected() {
      return this.selectedItems.length;
    },
    numberOfSelectableItems() {
      return this.products.filter(x => x.selectable).length;
    }
  },
  methods: {
    clear() {
      this.selectedItems = [];
    },
    itemClick(product) {
      let maxSelectableItem = parseInt(this.maxSelectable);
      let isSelectedBefore = this.selectedItems.findIndex(selectedItem => {
        return selectedItem.id == product.id;
      });
      if (product.selectable) {
        if (isSelectedBefore != -1) {
          this.products.find(x => x.id == product.id).count = 1;
          this.selectedItems.splice(isSelectedBefore, 1);
        } else {
          // This will be use if user selected before (NOT READY YET!)
          // this.selectedItems.forEach(selectedItem => {
          //   if(maxSelectableItem != -1 && selectedItem.selectable == false) {
          //     maxSelectableItem = maxSelectableItem + 1
          //   }
          // });
          if (
            maxSelectableItem != -1 &&
            this.selectedItems.length >= maxSelectableItem
          ) {
            return this.showModal(this.texts.maxSelectable);
          }
          this.selectedItems.push({ ...product });
          this.$emit("component-updated", {
            selected: this.selectedItems
          });
        }
      }
      this.updateComponentStatus();
    },
    isSelected(product) {
      const isSelected = this.selectedItems.find(item => {
        return item.id == product.id;
      });
      return !!isSelected;
    },
    decrease(product) {
      let index = this.selectedItems.findIndex(selectedItem => {
        return selectedItem.id == product.id;
      });
      if (index !== -1) {
        if(product.count > 1) {
          this.selectedItems[index].count--;
          this.products.find(x => x.id == product.id).count--;
        } else {
          this.selectedItems.splice(index, 1);
        }
      }
      this.updateComponentStatus();
    },
    increase(product) {
      this.selectedItems.find(x => x.id == product.id).count++;
      this.products.find(x => x.id == product.id).count++;
      this.updateComponentStatus();
    },
    updateComponentStatus() {
      let minSelectableItem = parseInt(this.minSelectable);
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: minSelectableItem != -1 ? this.selectedItems.map(x => x.value * x.count).reduce((a, b) => a + b, 0) >= minSelectableItem : !!this.selectedItems.length
      });
    },
    sendProducts() {
      let minSelectableItem = parseInt(this.minSelectable);
      if (!this.selectedItems.length || this.selectedItems.map(x => x.value * x.count).reduce((a, b) => a + b, 0) < minSelectableItem) {
        // this.showModal("<div class='pb-5'>Bitte wählen Sie mindestens ein <p>produkt aus.</p></div>");
        this.$eventHub.$emit("done-event-trigger", {
          parent: this,
          status: false,
          message: `<div class='pb-5'>${this.texts.required}</div>`
        });
        return;
      }
      const endpoint = this.endpoint;
      const formData = {
        selectedProducts: this.selectedItems
      };
      this.$store.dispatch("sendProducts", { formData, endpoint }).then(r => {
        if (r.response) {
          // console.log(this.successAction, this);
          const fn = this.successAction.fn;
          const params = this.successAction.params;
          this[fn](params, this);
          this.$eventHub.$emit("done-event-trigger", {
            parent: this,
            status: true
          });
          return;
        }
        this.$eventHub.$emit("done-event-trigger", {
          parent: this,
          status: false
        });
      });
      // console.log("inside send products", this.selectedItems);
    }
  },
  mounted() {
    /*
       add get products call to api and set the products to selectable or not.
    */
    this.$eventHub.$on("sendProducts-event", this.sendProducts);
  },
  beforeDestroy() {
    this.clear();
    this.$eventHub.$off("sendProducts-event", this.sendProducts);
  }
};
</script>

<style scoped>
.products-container {
  max-width: 1400px;
}
.products-counter {
  margin-right: 90px;
}
</style>
